import React, { useState, useMemo } from 'react';
import type { FC, PropsWithChildren } from 'react';
import { Context } from './context';

interface ProviderProps extends PropsWithChildren {}

export const ComplaintProvider: FC<ProviderProps> = ({ children }) => {
  const [generated, setGenerated] = useState(false);

  const value = useMemo(() => {
    return {
      generated,
      setGenerated,
    };
  }, [generated]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
